module.exports = __webpack_public_path__ + "static/street-contxt-logo-fbd5158001e143ea1289a82383227bfb.png";